<template>
  <service>
    <div class="service-add">
      <div class="element-1">
        <div class="input-item your-service">
          <h3>YOUR SERVICE</h3>
          <dropdown-menu-type-3
            :data="speciality"
            v-model="setSpeciality"
            :init-index="detailData.speciality"
          ></dropdown-menu-type-3>
        </div>
        <div class="input-item price">
          <h3>CURRENCY</h3>
          <dropdown-menu-type-3
            :data="currencyUnit"
            v-model="setCurrencyUnit"
            :init-index="detailData.currencyUnit"
          ></dropdown-menu-type-3>
        </div>
        <div class="input-item price">
          <base-input-type-1
            v-on:model="v => setPrice(v)"
            :initValue="detailData.price"
            label="PRICE"
            placeholder="price"
            inputType="number"
          ></base-input-type-1>
        </div>
      </div>
      <div class="element-1">
        <div class="input-item">
          <h3>PORTFOLIO – CAN UPLOAD MAXIUM 6 PHOTO</h3>
          <div class="upload-box">
            <image-upload-type-4
              v-on:model="v => setPortfolio(v)"
              :importPreviewImages="detailData.portfolio"
              directory="/service_portfolio"
            ></image-upload-type-4>
          </div>
        </div>
      </div>
      <div class="element-1">
        <div class="input-item promote">
          <h3>DO YOU WANT TO PROMOTE YOUR PHOTOGRAPHY ON LANDING PAGE?</h3>
          <dropdown-menu-type-3
            v-on:model="v => setPromote(v)"
            :data="promote"
            :initIndex="detailData.promote"
          ></dropdown-menu-type-3>
        </div>
        <div class="input-item preview">
          <base-button-type-1
            text="PREVIEW"
            typeColor="white"
          ></base-button-type-1>
        </div>
      </div>
      <div class="element-1">
        <div class="input-item">
          <h3>ABOUT YOUR SERVICE</h3>
          <textarea v-model="forms.aboutYourService"></textarea>
        </div>
      </div>
      <div class="element-1">
        <div class="input-item">
          <h3>
            WHAT YOU OFFER (HOW MANY PICTURE YOU WILL PROVIDE TO CUSTOMER)
          </h3>
          <textarea v-model="forms.whatYouOffer"></textarea>
        </div>
      </div>

      <div class="element-1">
        <div class="input-item final-preview" style="opacity: 0">
          <base-button-type-1
            text="PREVIEW"
            typeColor="white"
          ></base-button-type-1>
        </div>
        <div class="input-item submit">
          <base-button-type-1
            text="CANCEL"
            typeColor="white"
            @click="$router.push({ path: '/photographer/service' })"
          ></base-button-type-1>
          <base-button-type-1
            text="OK"
            typeColor="blue"
            @click="save"
          ></base-button-type-1>
        </div>
      </div>
    </div>
  </service>
</template>

<script>
import Service from './Service'
import DropdownMenuType3 from '../common/DropdownMenuType3'
import BaseButtonType1 from '../common/form-elemnets/BaseButtonType1'
import { getSpecialties } from '../../api/common_code'
import { defaultStore } from '../../library/firebase'
import ImageUploadType4 from '../common/ImageUploadType4'
// import BaseInputType2 from '@/components/common/form-elemnets/BaseInputType2'
import BaseInputType1 from '../common/form-elemnets/BaseInputType1'
import * as _ from 'lodash'
import { getProfile } from '../../api/profile'
import { getHoliday } from '../../api/availability'

export default {
  name: 'service-add',
  components: {
    BaseInputType1,
    // BaseInputType2,
    ImageUploadType4,
    BaseButtonType1,
    DropdownMenuType3,
    Service
  },
  data() {
    return {
      city: {},
      speciality: {},
      currencyUnit: {},
      forms: {
        portfolio: [],
        promote: 'true',
        aboutYourService: '',
        whatYouOffer: '',
        speciality: '',
        specialityTitle: '',
        mainImage: '',
        price: '',
        delete: false,
        city: '',
        rating: 0,
        holidays: []
      },
      promote: {
        true: {
          title: 'YES',
          sort: 0
        },
        false: {
          title: 'NO',
          sort: 1
        }
      },
      detailData: {
        portfolio: [],
        promote: 'true',
        aboutYourService: '',
        whatYouOffer: '',
        speciality: '',
        specialityTitle: '',
        mainImage: '',
        price: ''
      },
      targetId: '',
      yourCity: '',
      setSpeciality: '',
      setCurrencyUnit: ''
    }
  },
  created() {
    this.checkProfile()
    this.checkSetCity()
    this.getDefaultData()
    this.checkHolidays()
    this.targetId = _.cloneDeep(this.$route.query.id)
    // console.log('targetId:', this.targetId)
  },
  mounted() {
    if (this.$route.query.id) {
      this.getServiceDetail()
    }
  },
  watch: {
    setSpeciality(v) {
      this.forms.speciality = v
      this.forms.specialityTitle = this.speciality[v].title
    },
    setCurrencyUnit(v) {
      this.forms.currencyUnit = v
    }
  },
  methods: {
    checkProfile() {
      getProfile(this.$store.getters.userInfo.uid).then(() => {
        // console.log('check service add profile', profile)
      })
    },
    checkSetCity() {
      defaultStore
        .collection('photographers_service_area')
        .doc(this.$store.getters.userInfo.uid)
        .get()
        .then(doc => {
          if (doc.exists) {
            // console.log('Your area city :', doc.data().city)
            this.yourCity = doc.data().city
          } else {
            alert('First you should to add service area.')
            this.$router.push({ path: '/photographer/service/area' })
          }
        })
    },
    setPrice(v) {
      // console.log('price:', v)
      this.forms.price = v
    },
    setPortfolio(v) {
      this.forms.portfolio = v
    },
    setPromote(v) {
      // console.log('promote:', v)
      this.forms.promote = v
    },
    async getDefaultData() {
      // 알수 없는 오류로 ... 우선 이렇게 처리
      defaultStore
        .collection('currency_unit')
        .get()
        .then(doc => {
          const obj = {}
          doc.forEach(doc => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, ' => ', doc.data())
            obj[doc.id] = doc.data()
          })

          this.currencyUnit = obj
        })

      getSpecialties().then(res => {
        // console.log('Service add:', res)
        this.speciality = res
      })
    },
    getServiceDetail() {
      // console.log('service detail', this.$route.query.id)
      defaultStore
        .collection('photographers_service')
        .doc(this.$route.query.id)
        .get()
        .then(doc => {
          // console.log(doc.data())
          this.detailData = doc.data()
          this.forms = doc.data()
        })
    },
    save() {
      this.forms.mainImage = this.forms.portfolio[0].thumbnailFullPath
      this.forms.uid = this.$store.getters.userInfo.uid
      if (typeof this.$store.getters.userInfo.firstName == 'undefined') {
        this.$store.getters.userInfo.firstName = ''
      }
      this.forms.name =
        this.$store.getters.userInfo.name +
        ' ' +
        this.$store.getters.userInfo.firstName
      this.updateHolidays()
    },
    async landingSave(serviceId = '') {
      this.forms.city = this.yourCity
      if (this.forms.promote === 'true') {
        this.forms.portfolio.forEach(v => {
          return defaultStore
            .collection('landing_images')
            .doc(v.imageUid)
            .set({
              uid: this.$store.getters.userInfo.uid,
              use: true,
              image: v,
              speciality: this.forms.speciality,
              city: this.forms.city,
              serviceId: serviceId
            })
            .then(result => {
              return result
              // console.log('landing success', result)
            })
        })
      }
    },
    updateHolidays() {
      // todo: 현재의 프로필중 조회용 데이터 셋에 set 해준다.
      getHoliday(this.$store.getters.userInfo.uid).then(res => {
        console.log('holiday:', res)
        if (res) {
          Object.assign(this.forms, { holidays: res })
          if (this.targetId) {
            defaultStore
              .collection('photographers_service')
              .doc(this.targetId)
              .update(this.forms)
              .then(res => {
                console.log('edit success', res)
                this.landingSave(this.targetId).then(() => {
                  this.$router.push({ path: '/photographer/service' })
                })
              })
          } else {
            defaultStore
              .collection('photographers_service')
              .add(this.forms)
              .then(res => {
                console.log('Add success', res)
                this.landingSave(res.id).then(() => {
                  this.$router.push({ path: '/photographer/service' })
                })
              })
          }
        } else {
          alert('Setup the holiday')
        }
      })
    },
    checkHolidays() {
      getHoliday(this.$store.getters.userInfo.uid).then(res => {
        console.log('check holidays:', res)
        if (!res) {
          alert('Setup the holiday')
          this.$router.push({ path: '/photographer/availability/holiday' })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.service-add {
  width: 100%;
  height: 900px;
  margin-top: 40px;
  border: 1px solid #e7e7e7;

  .element-1 {
    &:nth-child(1) {
      margin-top: 22px;
    }

    margin: 14px 20px 0 20px;
    display: flex;
    justify-content: flex-start;

    .input-item {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      /*border: 1px solid red;*/

      textarea {
        height: 100px;
        background-color: #ffffff;
        border: solid 1px #e7e7e7;
        width: 1030px;
        outline: none;
        resize: none;
      }

      h3 {
        font-size: 14px;
        font-weight: 600;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: 1px;
        margin: 0 0 5px 0;
      }

      &.your-service {
        width: 50%;
      }

      &.price {
        margin-left: 40px;
        width: 30%;
      }

      &.promote {
        width: 83%;
      }

      &.preview {
        margin-left: 1%;
        width: 16%;
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;

        .base-button-type-1 {
          height: 52px;
        }
      }

      .upload-box {
        width: 1040px;
        height: 226px;
        background-color: #f5f5f5;
        border: solid 1px #e7e7e7;
        position: relative;

        .base-button-type-1 {
          position: absolute;
          right: 10px;
          bottom: 10px;
        }
      }

      &.submit {
        flex-direction: row;
        justify-content: space-between;
        width: 320px;
        margin-left: 215px;
      }

      &.final-preview {
        width: 500px;
      }
    }
  }
}
</style>
